import { render, staticRenderFns } from "./Receiptvoucher.vue?vue&type=template&id=28057cb6&scoped=true"
import script from "./Receiptvoucher.vue?vue&type=script&lang=js"
export * from "./Receiptvoucher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28057cb6",
  null
  
)

export default component.exports